import React, { useState, useCallback, useEffect, useRef } from "react";
import { ThemeProvider } from "@mui/material/styles";

import { Grid, Card } from "@mui/material";

import { StyledMultilineTextField, theme } from "../StyledComponents";

const Transcription = React.memo(({ activeSection, data }) => {
  const [voiceText, setVoiceText] = useState("");

  useEffect(() => {
    if (data) {
      setVoiceText((prev) => prev + data + "\n");
    }
  }, [data]); // runs every time parent sends updated text

  return (
    <ThemeProvider theme={theme}>
      {/* {activeSection && ( */}
      <Card
        sx={{
          borderRadius: "10px",
          boxShadow: "0 4px 4px 0 #C7C7CC inset",
          backgroundColor: "#FFF",
        }}
      >
        <Grid container spacing={2} sx={{ padding: "10px" }}>
          <Grid item xs={12} md={12} sm={12}>
            <StyledMultilineTextField
              id="outlined-multiline-static"
              //   label="Transcription"
              multiline
              rows={2}
              value={voiceText || "No Transcript Available"}
              fullWidth
              InputProps={{
                readOnly: true,
              }}
            />
          </Grid>
        </Grid>
      </Card>
      {/* )} */}
    </ThemeProvider>
  );
});

export default Transcription;
